
/* APPLICATION ROUTE CONSTANTS */

module.exports = Object.freeze({
  
    // Status
    STATUS_REGISTER:'Register',
    LOGIN_BY_QR_CODE:'/loginByQRCode',
    /* Routers Link supplier_app */
    CONFIG: '/config',
    HOME: '/home',
    DASHBOARD: '/dashboard',
    MACHINE_UTILIZATION_DASHBOARD: '/machine-utilization-dashboard',
    OPERATOR_UTILIZATION_DASHBOARD: '/operator-utilization-dashboard',
    OVERVIEW: '/overview',
    OVERVIEWMACHINES: '/overviewmachines',
    INBOX: '/inbox',
    OUTBOX: '/outbox',
    DEPARTMENTS: '/departments',
    MACHINES: '/machines',
    CUSTOMERS: '/customers',
    CHECKLIST: '/checklist',
    SIZE: '/size',
    JOBSTATUS: '/jobstatus',
    REASON: '/reason',
    STORE: '/store',
    CHEMICAL: '/chemical-batch',
    OPERATORCHECKLISTREPORTS: '/operatorChecklistReports',
    MACHINEIDLESTATUSREPORTS: '/machineIdleStatusReports',
    JOBCARDANALYTICS: '/jobcardAnalytics',
    ORDERCONFIRMATION: '/orderconfirmation',
    CLOSECURRENTJOBCARD: '/closecurrentjobcard',
    PRODUCTIONSTATUSREPORTS: '/productionStatusReports', 
    JOBCARDSTATUSREPORTS: '/jobcardStatusReports', 
    DEPTACKSTATUSREPORTS: '/deptAckStatusReports', 
    OPERATORREPORTS: '/operatorsReports', 
    OPERATOREFFICIENCY: '/operatorsEfficiency', 
    REWORKJOBCARD: '/reWorkJobCard',
    OEEDASHBOARD: '/oeeDashboard',
    CHEMICALBATCHREPORTS: '/chemicalBatchReports',
    BULKCONSUMPTIONREPORTS: '/bulkConsumptionReports',
    GENERALREPORTS:'/generalReports',
    SUMMARYREPORT: '/summaryreport',
    REWORKREPORTS:'/reworkReports',
    QUALITYCERTIFICATE: '/qualityCertificate',
    CONSUMPTIONQTYREPORT: '/consumptionQuantityReports',
    REVISING_NUMBER: '/revising-number',
    // MASTER
    DEPARTMENT: '/department',
    GENERATEJOBCARD: '/generatejobcard',
    MACHINESTATUS: '/machinestatus',
    OPERATORCHECKLIST: '/operatorchecklist',
    ACKNOWLEDGEJOBCARD: '/acknowledgejobcard',
    STARTSTOPJOBCARD: '/startStopJobCard',
    CONSUMPTION: '/consumption',
    MENU_CONFIGURATION: '/menu-configuration',
    MASTER :{
        STATUS:{
            Inactive:"Inactive",
            Active:"Active",
            Idle:"Idle",
            Complete:"Complete",
        },
        TOAST:{
            success:"success",
            error:"error",
        },
        VALIDATION:{
            maxLengthCode:"30",
            maxLengthName:"100"
        },
        DEPARTMENT:{
            list:'getDepartmentsList',
            ADD: 'addDepartment',
            DELETE:'deleteDepartmentById',
            name:'department',
            UPDATE: 'updateDepartmentById',
            SEARCH: 'searchDepartmentMaster',
            TARGET: 'setDepartmentTarget'
        },
        MACHINES:{
            list:'getMachinesList',
            name:'machines',
            ADD: 'addMachine',
            DELETE:'deleteMachineById',
            UPDATE:'updateMachineById',
            SEARCH: 'searchMachineMaster',
            UNASSIGN: 'unassignMachineJobcard',
        },
        REVISING_NUMBER:{
            list:'getRevisingNumberList',
            name:'revisingNumber',
            ADD:'addRevisingNumber',
            UPDATE:'updateRevisingNumber',
            DELETE:'deleteRevisingNumber',
            AUDIT:'getRevisingNumberAuditLog',
            REPORT_TYPES:[
                { value:'QUALITY_CERTIFICATE', label:'Quality Certificate' },
                { value:'BATCH_REPORT', label:'Batch Report' },
            ],
        },
        CUSTOMERS:{
            list:'getCustomersList',
            name:'customers',
            ADD: 'addCustomer',
            DELETE:'deleteCustomerById',
            UPDATE:'updateCustomerById',
            SEARCH: 'searchCustomerMaster',
        },
        CHECKLIST:{
            list:'getChecklistList',
            name:'checklist',
            ADD: 'addChecklist',
            DELETE:'deleteChecklistById',
            UPDATE:'updateChecklistById',
            SEARCH: 'searchCheckListMaster',
        },
        USERS:{
            list:'getUserDetails',
            name:'users',
            ADD: 'addUser',
            DELETE:'deleteUserById',
            UPDATE:'updateUserById',
            SEARCH: 'searchUserMaster',
            ADMIN:'ADMIN',
            OPERATOR:"OPERATOR",
            TEAMLEAD:"TEAMLEAD",
            SUPERVISOR: "SUPERVISOR"
        },
        ROLE:{
            name:'role',
            list:'getRoleList',    
            ADMIN:'admin'
        },
        CHECKLIST_TYPE:{
            name:'checklistType',
            list:'getChecklistType',
        },
        SIZE:{
            list:'getSizeList',
            name:'size',
            ADD: 'addSize',
            DELETE:'deleteSizeById',
            UPDATE:'updateSizeById',
            UPLOAD: 'uploadSize',
            SEARCH: 'searchSizeMaster',
        },
        PROCESS:{
            list:'getProcessList',
            name:'process',
            ADD: 'addProcess',
            DELETE:'deleteProcessBySizeId',
            UPDATE:'updateProcessBySizeId',
            UPLOAD: 'uploadProcess'
        },
        JOBSTATUS:{
            list:'getJobStatusList',
            name:'jobstatus',
            ADD: 'addJobStatus',
            DELETE:'deleteJobStatusById',
            UPDATE:'updateJobStatusById',
            SEARCH: 'searchJobStatusMaster',
        },
        REASON:{
            list:'getReasonList',
            name:'reason',
            ADD: 'addReason',
            DELETE:'deleteReasonById',
            UPDATE:'updateReasonById',
            SEARCH: 'searchReasonMaster',
        },
        PLANTYPE:{
            list:'getPlanTypeList',
            name:'plantype',
        },
        SEQUENCES:{
            list:'getSequenceList',
            name:'sequences',
        },
        CHEMICAL:{
            list:'getChemicalsList',
            ADD: 'addChemical',
            DELETE:'deleteChemicalById',
            name:'Chemical',
            UPDATE: 'updateChemicalById',
            SEARCH: 'searchChemicalMaster',
        },
        CHEMICAL_SEQUENCES:{
            list:'getChemicalSequenceList',
            name:'chemicalSequences',
        },
        CONSUMABLE:{
            list:'getConsumablesList',
            name:'consumable',
            ADD: 'addConsumable',
            DELETE:'deleteConsumablesById',
            UPDATE:'updateConsumablesById',
            UPLOAD: 'uploadConsumables',
            SEARCH: 'searchConsumables',
        },
        CONSUMPTIONTYPES:{
            name:'consumptionTypes',
            list:'getConsumptionTypesList',   
        }
    },
    TRANSACTION: {
        GENERATEJOBCARD:{
            list:'getJobcardList',
            ADD: 'addJobCard',
            name:'generatejobcard',
            // DELETE:'deleteDepartmentById',
            open_jobcard: {
                list:'getAllOpenJobcards',
                name: 'getAllOpenJobcards'
            }
            // UPDATE: 'updateDepartmentById'
        },
        REWORKJOBCARD:{
            list:'getOpenReworkJobcardList',
            name:'ReworkJobcard',
            open_reworkjobcard: {
                list:'getOpenReworkJobcardList',
                name: 'ReworkJobcard'
            }
        },
          MACHINEIDLEREASON: {
            list: 'getMachineIdleReasonList',
            status_list: "getMachineIdleList",
            status_name: "machineIdleStatusTransaction",
            name:'machineIdleReason',
            ADD: 'addMachineIdleReason',
            UPDATE: 'updateMachineIdleReason'
        },
        OPERATORCHECKLIST: {
            ADD: 'addOperatorChecklist',
            name:'operatorChecklist',
        },
        ACKNOLEDGEJOBCARD : {
            ADD: 'ackJobCard',
        },
        JOBCARDSTATUSTRANSACTION:{
            name:'jobcardstatustransaction'
        }, ORDERCONFIRMATION:{
            name:'orderconfirmationtransaction'
        }
    },
    REPORTS: {
        MACHINEIDLESTATUS:{
            list:'getmachineIdleStatusReports',
            name:'machineIdleStatusReports'
        },
        OPERATORCHECKLIST:{
            list:'getoperatorChecklistReports',
            name:'operatorChecklistReports'
        },
        JOBCARDSTATUS: {
            list:'getjobcardStatusReports',
            name:'jobcardStatusReports'
        },
        DEPTACKSTATUS: {
            list:'getdeptAckStatusReports',
            name:'deptAckStatusReports'
        },
        CHEMICALBATCHREPORTS: {
            list:'getChemicalBatchReports',
            name:'chemicalBatchReports'
        },
        BULKCONSUMPTIONREPORTS: {
            list:'getBulkConsumptionReports',
            name:'bulkConsumptionReports',
            report:"BULK_CONSUMPTION_REPORTS"
        },
        PRODUCTIONSTATUS:{
            list:'getproductionStatusReports',
            name:'productionStatusReports',
            pageName:'PRODUCTION_STATUS_REPORTS'
        },
        OPERATORREPORTS: {
            list:'getOperatorsReports',
            name:'operatorsReports'
        },
        OPERATOREFFICIENCY: {
            list:'getOperatorsEfficiency',
            name:'operatorsEfficiency'
        },
        SUMMARYREPORT: {
            list:'getSummaryReport',
            name:'summaryReport'
        },
        QUALITYCERTIFICATE: {
            list:'getAllCompletedJobcards',
            name:'qualityCertificate'
        },
        REWORKREPORTS: {
            list:'getReworkReports',
            name:'reworkReports',
            pageName:'REWORK_REPORTS'
        },
        MATERIALTRACEREPORT: {
            list:'filterMaterialTraceNumber',
            name:'materialTraceReport',
            update:'updateMaterialTraceNumber'
        },
        CONSUMPTIONQTYREPORT: {
            list:'getConsumptionQuantityReports',
            name:'consumptionQuantityReports'
        },
    },

    TRANSACTION_STATUS: {
        OPEN:"Open",
        ACKNOWLEDGE:"Acknowledged",
        INPROGRESS:"Inprogress",
        STOPPED:"Stopped",
        CLOSED:"Closed",
        COMPLETED:"Completed",
        COMPLETE: "Complete"
    },
    // SUPPILER
    SUPPILER_REGISTRATION: '/supplier-registration',
    SUPPILER_LIST: '/supplier-list',
    SUPPILER_MASS_UPLOAD: '/supplier-mass-upload',
    SUPPLIER_MASTER_CREATE: '/supplier-master-creation',
    SUPPLIER_SELF_REGISTRATION: '/supplier-self-registration',
    SUPPLIER_DETAILED_PAGE_CREATE:'/supplier-details',
    SUPPLIER_DETAILED_PAGE_WORKFLOW:'/supplier-details-workflow',

    // SOURCING 
    SOURCING_PURCHASE_REQUISITION: '/purchase-requisition',
    SOURCING_REQUEST_FOR_QUOTATION: '/request-for-quotation',
    SOURCING_CREATE_RFQ: '/create-request-for-quotation',
    SOURCING_QUOTATION: '/quotation',
    SOURCING_CREATE_QUOTATION:'/create-quotation',
    SOURCING_PURCHASE_REQUISITION_CREATE: '/create-purchase-requisition',
    SOURCING_PURCHASE_REQUISITION_DETAILED_PAGE: '/purchase-requisition-details',
    SOURCING_COMMERCIAL_EVALUATION: '/commercial-evaluation',
    SOURCING_TECHNICAL_EVALUATION: '/technical-evaluation',
    SOURCING_PURCHASE_ORDER_CREATION: '/create-purchase-orders',
    SOURCING_SUPPLIER_RFQ_DETAILS: '/supplier-rfq-details',
    SOURCING_RFQ_DETAILS: '/rfq-details',
  

    //PO COLLABRATION
    POCOLLABRATION_PURCHASE_ORDER:'/purchase-order',
    POCOLLABRATION_PURCHASE_ORDER_CREATION:'/create-purchase-order',
    POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE:'/purchase-order-detail',
    POCOLLABRATION_GOODS_RECEIVED_NOTE:'/goods-received-note',
    POCOLLABRATION_SERVICE_ENTRY_SHEET:'/service-entry-sheet',
    POCOLLABRATION_INVOICE_CREATION:'/create-invoice',
    POCOLLABRATION_INVOICE:'/invoice',
    POCOLLABRATION_INVOICE_DETIAILS:'/invoice-details',
    POCOLLABRATION_PAYMENT:'/payments',
    POCOLLABRATION_ASN:'/advanced-shipping-notice',    
    POCOLLABRATION_ASN_DETAIL_PAGE:'/asn-detail',
    POCOLLABRATION_ASN_CREATION:'/create-asn',
    POCOLLABRATION_GRN_CREATION:'/create-grn',
    POCOLLABRATION_GRN_DETAILS:'/goods-received-note-details',
    POCOLLABRATION_SES_CREATION:'/create-entrysheet',
    POCOLLABRATION_SCHEDULING_AGREEMENT:'/scheduling-agreement',
    POCOLLABRATION_SERVICE_ENTRY_DETAILS:'/service-entry-sheet-details',
    
    //SAP REPROCESS
    SAPREPROCESS_GRN_REPROCESS:'/grn-reprocess',
    SAPREPROCESS_SES_REPROCESS:'/ses-reprocess',
    SAPREPROCESS_INVOICE_REPROCESS:'/invoice-reprocess',

    
    //USER DELEGATION
    USER_DELEGATION:'/user-deletion',

    //ADMIN
    ADMIN_MANAGE_USER:'/manage-user',
    ADMIN_MANAGE_ADD_USER:'/manage-add-user',
    ADMIN_MANAGE_EDIT_USER:'/manage-edit-user',
    ADMIN_MANAGE_USER_DETAILS:'/manage-user-detials',
    ADMIN_MANAGE_ROLE:'/manage-role',

    //AUCTION
    AUCTION_REVERSE_AUCTION_LIST:'/reverse-auction-list',
    AUCTION_REVERSE_AUCTION_CREATION:'/create-auction',
    AUCTION_REVERSE_AUCTION_HISTORY:'/reverse-auction-history',
    AUCTION_FORWARD_AUCTION_LIST:'/forward-auction-list',
    AUCTION_FORWARD_AUCTION_HISTORY:'/forward-auction-history',

    //CONTRACT MANAGEMENT  
    CONTRACTMANAGEMENT_CONTRACT_GENERATE_LIST:'/contract-generate-list',
    CONTRACTMANAGEMENT_CONTRACT_REVIEW_LIST:'/contract-review-list',
    CONTRACTMANAGEMENT_CONTRACT_DRAFT_TO_FINAL_LIST:'/contract-draft-final-list',
    CONTRACTMANAGEMENT_MONITORING_LIST:'/contract-monitoring-list',

    //GATEPASS
    GATEPASS_GATEPASS_CREATE:'/gatepass-create',
    GATEPASS_GATEPASS_LIST:'/gatepass-list',
    GATEPASS_GATEPASS_DETAIL_PAGE:'/gatepass-detail',
  
    //DELEGATION
    DELEGATION_TASK:'/task-delegation',
    DELEGATION_USER:'/user-delegation',

    //SINGLE SOURCING
    SINGLESOURCING_SINGLE_SOURCING_CREATION:'/create-single-source',
  
    /* Routers Link */
    NOT_FOUND: "pages-faq.html",
    LOGIN: "/login",
    REGISTER: '/registeration',
    CALLBACK: '/callback',

    
    SETTINGS: '/settings',
    PROFILE: '/profile',
    COMPANY: '/company',
    PAYMENT: '/payment',
    USERS: '/users',
    LOCATION: '/location',
    UPCOMING_SHIFT: '/upcoming-shifts',
    ONGOING_SHIFT: '/todays-shifts',
    PAST_SHIFT: '/past-shifts',
    EVENT_DETAILS: '/event-details',
    EDIT_TIMESHEET: '/edit-timesheet',
    MANAGE_SHIFT: '/manage-shift',
    BOOKSHIFT: '/bookshift',


    /* Positions Master Data */

    ROW_PER_PAGE : [10, 50, 100, 300, 500],
    SETQUANTITYPERJOBCARD : 2000,
    PER_PAGE:10,
})

